export default __webpack_public_path__ + "static/media/menu.3f33db8d.jpg";